export default "__VITE_ASSET__B_S3OX0H__"